const confirmForgotPasswordES = {
	title: "Restablecer contraseña",
	subtitle: "Introduce el código que te enviamos y elige una nueva contraseña.",
	email: "Correo electrónico",
	code: "Código de confirmación",
	password: "Nueva contraseña",
	confirmPassword: "Confirmar contraseña",
	submit: "Restablecer contraseña",
	submitting: "Actualizando...",
	success: "Tu contraseña se ha actualizado correctamente.",
	toast: {
		required: "Todos los campos son obligatorios.",
		weakPassword:
			"La contraseña debe tener al menos 8 caracteres, una mayúscula, un número y un punto (.)",
		mismatch: "Las contraseñas no coinciden.",
		invalidCode: "Código inválido o expirado.",
		error: "No se pudo restablecer la contraseña. Inténtalo de nuevo.",
	},
};

export default confirmForgotPasswordES;
